import { Button, Checkbox, IMaskedInputChangeEventExtra, InputAdornment, MaskedInput, UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IBookedFromDeveloperConfirmModalProps {
  phone: string;
  onPhoneChange(value: string, extra: IMaskedInputChangeEventExtra): void;
  onTermChange(event: React.ChangeEvent<HTMLInputElement>, value: boolean): void;
  onSubmit(): void;
  disabled: boolean;
  termsAgreementUrl: string;
}

export const BookedFromDeveloperConfirmModal = ({
  phone,
  onPhoneChange,
  onTermChange,
  termsAgreementUrl,
  disabled,
  onSubmit,
}: IBookedFromDeveloperConfirmModalProps) => {
  return (
    <div className={styles['container']}>
      <UIHeading2>Подберём похожую квартиру</UIHeading2>
      <div className={styles['phone']}>
        <div className={styles['label']}>Номер телефона</div>
        <div className={styles['row']}>
          <div className={styles['input']}>
            <MaskedInput
              value={phone}
              onChange={onPhoneChange}
              leftAdornment={<InputAdornment>+7</InputAdornment>}
              mask="(000) 000 00-00"
            />
          </div>
          <Button disabled={disabled} size="XS" theme="fill_primary" onClick={onSubmit}>
            Позвоните мне
          </Button>
        </div>
      </div>
      <div className={styles['terms']}>
        <Checkbox label="Соглашаюсь на " onChange={onTermChange} />
        <span>&#32;</span>
        <a target="_blank" className={styles['link']} href={termsAgreementUrl} rel="noreferrer">
          обработку персональных данных
        </a>
      </div>
    </div>
  );
};
